import { Component, Input } from "@angular/core"
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { StudentLoginModalComponent } from "../../../shared-components/modals/student-login-modal/student-login-modal.component"
import { AuthModalComponent } from "../../../shared-components/modals/auth-modal/auth-modal.component"
import { UserService } from "../../../services/user.service"
import { LTIMedia } from "../../../models/resource/media"

@Component({
    selector: "app-continue-modal",
    templateUrl: "./lti-continue-modal.component.html",
    styleUrls: ["./lti-continue-modal.component.less"],
})
export class LtiContinueModalComponent {
    @Input() public ltiMedia: LTIMedia

    constructor(
        public activeModal: NgbActiveModal,
        public userService: UserService,
        private modalService: NgbModal
    ) {}

    public openLTILoginModal() {
        this.activeModal.close()
        if (this.userService.hasStudentExperience()) {
            this.modalService.open(StudentLoginModalComponent)
        } else {
            const modalRef = this.modalService.open(AuthModalComponent)
            modalRef.componentInstance.description =
                "Log in to PBS LearningMedia to unlock interactive lessons and " +
                "tons of other features to bring your classroom to life"
        }
    }

    public goToLTIAsGuest() {
        this.activeModal.close()
        window.open(this.ltiMedia.getGuestURL(window.location.href), "_blank")
    }
}
